'use client'

import type {Shop} from '@/src/entities/shop'

import * as UI from './shop-form.styled'

export interface ShopItemProps {
  shop: Shop
  onSelect: () => void
  active: boolean
}

/**
 * Shop list item component
 *
 * Displays shop information in a selectable card format
 * Shows title, address, and work schedule
 */
export const ShopItem = ({onSelect, shop, active}: ShopItemProps) => {
  return (
    <UI.ShopItem onClick={() => onSelect()} $active={active} role="row" aria-label="shop-item">
      <UI.ShopItemName>{shop.title}</UI.ShopItemName>
      <UI.ShopItemAddress>
        <span data-address="">{shop.address}</span>
      </UI.ShopItemAddress>
      <UI.ShopItemSchedule>
        <span data-schedule="">{shop.work_schedule || ''}</span>
      </UI.ShopItemSchedule>
    </UI.ShopItem>
  )
}
